module.exports = __webpack_public_path__ + "img/info.8bfcfe71.svg";